import { Dispatch, SetStateAction, useEffect, useState } from "react";
import {
  Datepicker,
  MbscDatepickerCellClickEvent,
  MbscDatepickerPageLoadedEvent,
  MbscDateType,
} from "@mobiscroll/react";
import Form from "react-bootstrap/Form";
import {
  AppointmentMetaData,
  PatientDetails,
  ToasterObject,
} from "./interface-utils";
import {
  AppointmentCategory,
  IdLabelPair,
} from "../../api/api-mockups/interfaces";
import { getLocalDateString } from "./dateFormat";
import AsyncTypeahead, {
  DataListType,
  TypeHeadBase,
} from "../../components/AsyncTypeahead";
import {
  createAppointmentApi,
} from "../../api-helpers/AppointmentApiHelper";
import {
  AppointmentDto,
  AppointmentMode,
  AppointmentRescheduledReason,
  AppointmentType,
  BookedSlotsRequest,
  SaveAppointmentRequest,
  UpdateAppointmentData,
} from "appointment-experience-client";
import { createUsersApi } from "../../api-helpers/UserApiHelper";
import { createPatientApi } from "../../api-helpers/PatientApiHelper";
import { DatepickerBase } from "@mobiscroll/react/dist/src/core/components/datepicker/datepicker";
import { PatientPersonalInfo } from "patients-experience-client";
import Confirm from "./Confirm";
import {
  AdditionalAttributeInfo,
  MemberAnswerInfo,
} from "clinical-forms-experience-client";
import moment from "moment";
import { WorkflowState } from "common-util-experience-client";
import { useParams } from "react-router-dom";
import { LoadingHelper } from "../../components/loader/LoadingHelper";
import Spinner from "../../components/Spinner";
import { formatTime } from "../PatientProfile/commonUtils";
import { UserAvailabilities, UsersDto } from "users-experience-client";
import { createLocationApi } from "../../api-helpers/CommonUtilsApiHelper";
import { DateTime } from "luxon";
import {
  getTzIdentifier,
  TimeZoneKey,
} from "../../helper/momentTimezoneMapping";
import React from "react";
import { createClinicalFormsApi } from "../../api-helpers/ClinicalFormsApiHelper";
import { ClinicalFormsConstants } from "../ClinicalForms/ClinicalFormsConstants";
import { stripHtmlTags } from "../../helper/TextUtils";
import { ReactComponent as OutlookCalendar } from "../../assets/img/outlook-calendar.svg";
import "../../assets/scss/custom/_custom.scss";

import {
  ScheduleInformation,
  WorkingHours,
  DayOfWeek,
  NullableOption,
  ScheduleItem,
} from "@microsoft/microsoft-graph-types";
import { IValidateProps } from "@mobiscroll/react/dist/src/core/util/datetime";
import { AppointmentTypesConstants } from "../../constants/AppointmentTypes";
import { EventType, TimeSlot } from "../../interfaces/event";
import { UserContextHolder } from "../../auth/UserContextHolder";
import { Constants } from "../../constants/Lookups";
import { Appointments } from "../home/Appointments";
import AppointmentEventCalendar from "./AppointmentEventCalendar";
import { useRoleAuthorization } from "../../customHooks/useRoleAuthorization";
import { USER_ROLES } from "../../constants/UserRoles";

type Reschedule = {
  isSchedule: boolean;
  appointmentCategory: string;
};

type selectedPatient = {
  name: string;
  dob: string;
  id: string;
};

type TimeZones = {
  [key: string]: string;
};

interface AddAppointmentProps {
  appointmentId?: string;
  // patientId?: string;
  setOpenToaster: (toasterConfig: ToasterObject) => void;
  getAllAppointments?: () => void;
  isReschedule?: Reschedule;
  confirmType?: string;
  confirmPageAction?: (action: any) => void;
  offCanvasShow?: boolean;
  offCanvasComp?: string;
  setOffCanvasShow: Dispatch<SetStateAction<boolean>>;
  setOffCanvasComp: Dispatch<SetStateAction<string>>;
  loadAppointmentDetails?: () => void;
  reloadGrid?: () => void;
}

// let formData: SaveAppointmentRequest = {} as SaveAppointmentRequest;

const AddOneOne = ({
  appointmentId,
  // patientId,
  setOpenToaster,
  getAllAppointments,
  isReschedule,
  confirmType,
  confirmPageAction,
  offCanvasShow,
  offCanvasComp,
  setOffCanvasShow,
  setOffCanvasComp,
  loadAppointmentDetails,
  reloadGrid,
}: AddAppointmentProps) => {
  const appointmentApi = createAppointmentApi();
  const usersApi = createUsersApi();
  const patientApi = createPatientApi();

  // let patientContactinfo : PatientSelfContactInfo;

  const initialAppointmentData: SaveAppointmentRequest = {
    time: new Date(), // Current date-time
    // appointmentTimeZone: "UTC", // Empty string for timezone
    // appointmentDuration: 90, // Duration initially set to 0
    appointmentCategoryId: "", // Empty string for category ID
    patientIds: [], // Empty array for patient IDs
    email: "", // Empty string for email
    phone: "", // Empty string for phone number
    appointmentTypeId: "", // Empty string for appointment type ID
    appointmentModeId: "", // Empty string for appointment mode ID
    primaryCoachUserId: "", // Empty string for primary coach
    isRecurring: false, // Initially set to false for recurring
    reccuringFrequency: "", // Empty string for recurring frequency
    designerId: "", // Empty string for appointment designer ID
    designerStateId: "", // Empty string for appointment designer state `ID`
    source: "Coach", // Optional field, initially empty
    coachIds: [], // Empty array for coach IDs
    comment: "", // Empty string for comment
  };

  const initialPatientDetails: PatientDetails = {
    name: "",
    dob: "",
    emailList: [],
    contactList: [],
  };

  const initialAppointmentMetaData: AppointmentMetaData = {
    appointmentOccurrenceList: [],
    appointmentModes: [],
    appointmentTypeList: [],
  };

  const [patientselectedonback, setPatientSelectedonback] =
    useState<DataListType | null>(null);
  const [isPatientLoading, setIsPatientLoading] = useState(false);
  const [coachselectedonback, setcoachselectedonback] =
    useState<DataListType | null>(null);
  const [radioOption, setRadioOption] = useState("OneOne");
  const [displayBlockedOutlookTimeSlots, setDisplayBlockedOutlookTimeSlots] =
    useState(false);
  const [overrideBufferSlots, setOverrideBufferSlots] = useState(false);
  const [patientTimeZone, setPatientTimeZone] = useState("");
  const [displayTimezone, setDisplayTimezone] = useState<{
    patient: string;
    coach: string;
  }>({ patient: "--", coach: "--" });
  const [coachTimeZone, setCoachTimeZone] = useState("");

  // const [addAppointmentForm, setAddAppointmentForm] =
  //   useState<SaveAppointmentRequest>(initialAppointmentData);
  const [confirmPage, setConfirmPage] = useState(false);
  const [addAppointmentForm, setAddAppointmentForm] =
    useState<SaveAppointmentRequest>(initialAppointmentData);
  const [updateAppointmentForm, setUpdateAppointmentForm] = useState(
    {} as UpdateAppointmentData,
  );

  const [coachesForSelectedPatient, setCoachesForSelectedPatient] = useState<
    any[]
  >([]);
  const [coachesForSelectedAppointment, setCoachesForSelectedAppointment] =
    useState<any[]>([]);

  const [patientselected, setPatientselected] =
    useState<selectedPatient | null>(null);
  const [mode, setMode] = useState<AppointmentMode[]>([]);
  const [appointmentCategoryId, setAppointmentCategoryId] = useState("");
  const [appointmentType, setAppointmentType] = useState<AppointmentType[]>([]);
  const [allAppointmentTypeList, setAllAppointmentTypeList] = useState<
    AppointmentCategory[]
  >([]);
  const [appointmentMetaData, setAppointmentMetaData] =
    useState<AppointmentMetaData>(initialAppointmentMetaData);
  const [validated, setValidated] = useState(false);
  const [patientsList, setPatientTypeHeadList] = useState<DataListType[]>([]);
  const [coachList, setCoachList] = useState<DataListType[]>([]);
  const [patient, setPatient] = useState<PatientPersonalInfo | null>(null);
  const [appointmentDetails, setAppointmentDetails] =
    useState<AppointmentDto>();
  const [change, setchange] = useState(false);
  const [timeSlot, setTimeSlot] = useState<string | null>(null);
  const { patientId } = useParams();
  const [loading, setLoading] = useState<boolean>(false);
  const [timeSlotSelected, setTimeSlotSelected] = useState<boolean>(false);
  const [searchError, setSearchError] = useState<string>();
  const [updateDate, setUpdateDate] = useState<boolean>(false);
  const [submitClicked, setSubmitClicked] = useState<boolean>(false);
  const [bookedSlots, setBookedSlots] = useState<string[]>([]);
  const [elligibleUsers, setElligibleUsers] = useState<any[]>([]);
  const [availableSlots, setAvailableSlots] = useState<
    {
      slot: string;
      disabled: boolean;
      type?: (typeof EventType)[keyof typeof EventType];
    }[]
  >([]);
  const [displayAddDate, setDisplayAddDate] = useState<Date>(new Date()); // state for the selected date on the calendar
  const [patientSlots, setPatientSlots] = useState<string[]>([]);
  const locationApi = createLocationApi();
  const [selectedCoachTimeZone, setSelectedCoachTimeZone] = useState<
    string | null
  >(null);
  const clinicalformsApi = createClinicalFormsApi();
  const [assigningCareNote, setAssigningCareNote] = useState<boolean>(false);
  const [answers, setAnswers] = useState<MemberAnswerInfo[]>([]);
  const [additionalAnswers, setAdditionalAnswers] = useState<
    AdditionalAttributeInfo[]
  >([]);
  const [progressNotesId, setProgressNotesId] = useState<string | null>(null);
  const [editableNote, setEditableNote] = useState("");
  const [workSchedule, setWorkSchedule] = useState<WorkingHours | null>(null);
  const [outlookScheduleItems, setOutlookScheduleItems] = useState<
    NullableOption<ScheduleItem[]> | undefined
  >([]);
  const [userCalendarUnavailableRanges, setUserCalendarUnavailableRanges] =
    useState<TimeSlot[]>([]);

  const [invalidDates, setInvalidDates] = useState<
    MbscDateType[] | IValidateProps[]
  >([]);
  const [coachEmail, setCoachEmail] = useState("");
  const currentDate = new Date();
  const endOfMonth = new Date(
    currentDate.getFullYear(),
    currentDate.getMonth() + 1,
    1,
    0,
    0,
    0,
    -1,
  );
  const [selectedMonthRange, setSelectedMonthRange] = useState<{
    start: Date;
    end: Date;
  } | null>({
    start: new Date(currentDate.getFullYear(), currentDate.getMonth(), 1),
    end: endOfMonth,
  });
  const [enableSubmit, setEnableSubmit] = useState<boolean>(true);
  const [selectedCoach, setSelectedCoach] = useState<UsersDto>();
  const [selectedReason, setSelectedReason] = useState("");
  const [rescheduledReasons, setRescheduledReasons] = useState<
    AppointmentRescheduledReason[]
  >([]);

  const showEventCalendar = offCanvasComp === "eventCalendar";

  const monthChangeHandler = (
    args: MbscDatepickerPageLoadedEvent,
    inst: DatepickerBase,
  ) => {
    const start = new Date(args.firstDay);
    const end = new Date(args.lastDay);

    if (args.month) {
      const firstDayOfMonth = args.month;
      setDisplayAddDate(firstDayOfMonth);
      setAddAppointmentForm({
        ...addAppointmentForm,
        time: firstDayOfMonth,
      });
    }

    setSelectedMonthRange({ start, end });
  };

  useEffect(() => {
    if (outlookScheduleItems && displayTimezone.coach) {
      generateUnavailableRanges(outlookScheduleItems);
    }
  }, [
    outlookScheduleItems,
    displayTimezone.coach,
    displayBlockedOutlookTimeSlots,
  ]);

  const displayEventCalendar = () => {
    setOffCanvasComp("eventCalendar");
  };

  const hideEventCalendar = () => {
    setOffCanvasComp("");
  };
  // Function to load the next month's availability
  const fetchOutlookFreeBusySchedule = async (
    coachEmail: string,
    startDate: Date,
    endDate: Date,
  ) => {
    setLoading(true);
    setEnableSubmit(true);

    try {
      // fetch the coach's schedule
      const response =
        await appointmentApi.appointmentControllerGetUsersOutlookSchedule({
          userEmails: [coachEmail],
          startDateTime: startDate,
          endDateTime: endDate,
          availabilityViewInterval: 30,
        });

      const coachesSchedule = response.data[0] as ScheduleInformation;

      setWorkSchedule(coachesSchedule.workingHours || null);
      setOutlookScheduleItems(coachesSchedule.scheduleItems);

      // if the coach has a schedule, check for missing days
      if (coachesSchedule.workingHours?.daysOfWeek) {
        const allDays = [
          "sunday",
          "monday",
          "tuesday",
          "wednesday",
          "thursday",
          "friday",
          "saturday",
        ];
        const missingDays = allDays
          .filter(
            (day) =>
              !coachesSchedule.workingHours?.daysOfWeek!.includes(
                day as DayOfWeek,
              ),
          )
          .map((day) => day.slice(0, 2).toUpperCase());

        const invalidDateRules = [
          {
            recurring: {
              repeat: "weekly",
              weekDays: missingDays.join(","),
              interval: 1,
            },
          },
        ];

        setInvalidDates(invalidDateRules);
      }
    } catch (error) {
      setEnableSubmit(false);
      handleOpenToaster(
        "Scheduling is not currently available. Please try again later.",
        "error",
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const loadData = async () => {
      if (coachEmail && selectedMonthRange) {
        await fetchOutlookFreeBusySchedule(
          coachEmail,
          selectedMonthRange.start,
          selectedMonthRange.end,
        );
      }
    };

    loadData();
  }, [coachEmail, selectedMonthRange]);

  useEffect(() => {
    fetchTimeSlots();
  }, [overrideBufferSlots]);

  useEffect(() => {
    const loadData = async () => {
      LoadingHelper.showLoader(".addOneOne");
      if (isReschedule) {
        await setRadioOption(isReschedule.appointmentCategory);
      }

      getAppointmentModes();
      getAppointmentTypes();
      await setAppointmentTypesOnCategoryChange();
      await getAppointmentRescheduledReasons();

      if (patientId) {
        await getPatientDetailByPatientId(patientId);
      }
      if (appointmentId) {
        await getAppointmentDetailById(appointmentId);
      }
      LoadingHelper.hideLoader(".addOneOne");
    };
    loadData();
  }, []);

  const fetchBookedSlots = async () => {
    if (!addAppointmentForm.coachIds.length || !addAppointmentForm.time) {
      setLoading(false);
      return;
    }
    setLoading(true);

    try {
      await fetchTimeSlots();
    } catch (error) {
      console.error("Error fetching booked appointment time slots:", error);
    } finally {
      setLoading(false);
    }
  };

  const generateUnavailableRanges = (scheduleItems: ScheduleItem[]) => {
    const unavailableRanges: TimeSlot[] = [];

    scheduleItems?.map((item: ScheduleItem) => {
      if (item.start?.dateTime && item.end?.dateTime) {
        const start = DateTime.fromJSDate(
          new Date(
            DateTime.fromISO(item.start?.dateTime, { zone: "utc" }).toISO()!,
          ),
        ).setZone(timezoneMap[displayTimezone.coach]);
        const end = DateTime.fromJSDate(
          new Date(
            DateTime.fromISO(item.end?.dateTime, { zone: "utc" }).toISO()!,
          ),
        ).setZone(timezoneMap[displayTimezone.coach]);

        const appointmentStartTime = new Date(
          start.year,
          start.month - 1,
          start.day,
          start.hour,
          start.minute,
          start.second,
          start.millisecond,
        );

        const appointmentEndTime = new Date(
          end.year,
          end.month - 1,
          end.day,
          end.hour,
          end.minute,
          end.second,
          end.millisecond,
        );

        unavailableRanges.push({
          start: appointmentStartTime,
          end: appointmentEndTime,
          type: EventType.Outlook,
          isOutlook: true,
        });
      }
    });

    setUserCalendarUnavailableRanges(unavailableRanges);
  };

  const timezoneMap: TimeZones = {
    EST: "America/New_York",
    CST: "America/Chicago",
    PST: "America/Los_Angeles",
    MT: "America/Denver",
    MST: "America/Denver",
    AST: "Canada/Atlantic",
    HST: "Pacific/Honolulu",
  };

  const generatePatientSlots = (
    slots: { slot: string; disabled: boolean }[] | undefined,
  ) => {
    const allSlots = slots?.map((slot) => {
      const now = moment();
      const fullCoachTime = `${now.format("YYYY-MM-DD")} ${slot.slot}`;

      const coachTime = moment.tz(
        fullCoachTime,
        "YYYY-MM-DD hh:mm A",
        timezoneMap[displayTimezone.coach],
      );
      const patientTime = coachTime
        .clone()
        .tz(timezoneMap[displayTimezone.patient]); // Convert to the target time zone
      return patientTime.format("h:mm A");
    });
    setPatientSlots([...allSlots!]);
  };

  useEffect(() => {
    generatePatientSlots(availableSlots);
  }, [availableSlots, displayTimezone]);

  const fetchTimeSlots = async () => {
    setLoading(true);
    const slots = await generateTimeSlots();
    if (workSchedule && slots) {
      setAvailableSlots(slots);
    } else {
      setAvailableSlots([]);
    }
    setLoading(false);
  };

  const prepareUnavailableRanges = (
    coachAvailability: UserAvailabilities[],
    coachTimeZone: TimeZoneKey,
  ): TimeSlot[] => {
    return coachAvailability.map((availability) => {
      const start = DateTime.fromJSDate(
        new Date(availability.fromTime!),
      ).setZone(getTzIdentifier(coachTimeZone)); // Convert to coach's time zone
      const end = DateTime.fromJSDate(new Date(availability.toTime!)).setZone(
        getTzIdentifier(coachTimeZone),
      ); // Convert to coach's time zone

      return {
        start: start.toJSDate(), // Convert back to JavaScript Date object
        end: end.toJSDate(), // Convert back to JavaScript Date object
        isOutlook: true,
      };
    });
  };

  useEffect(() => {
    fetchBookedSlots();
  }, [
    addAppointmentForm.coachIds,
    addAppointmentForm.time,
    userCalendarUnavailableRanges,
    addAppointmentForm.appointmentTypeId,
  ]);

  useEffect(() => {
    const patientDisplayTimezone =
      patientTimeZone.match(/\((\w*)\)/)?.[1] || "--";
    const coachDisplayTimezone = coachTimeZone.match(/\((\w*)\)/)?.[1] || "--";
    setDisplayTimezone({
      ...{ patient: patientDisplayTimezone, coach: coachDisplayTimezone },
    });
  }, [patientTimeZone, coachTimeZone]);

  useEffect(() => {
    if (patientId) {
      setAppointmentTypesOnCategoryChange();
    }
  }, [patientId]);

  useEffect(() => {
    handleCoachTimeZone(coachTimeZone);
  }, [coachTimeZone]);

  useEffect(() => {
    handleAppointmentCategoryId(appointmentCategoryId);
  }, [appointmentCategoryId]);

  useEffect(() => {
    handlPatientTimeZone(patientTimeZone);
  }, [patientTimeZone]);

  const handleCoachTimeZone = (data: string | undefined) => {
    setCoachTimeZone(data!);
  };

  const handleAppointmentCategoryId = (data: string | undefined) => {
    setAddAppointmentForm({
      ...addAppointmentForm,
      appointmentCategoryId: data!,
    });
  };

  const handlPatientTimeZone = (data: string | undefined) => {
    setPatientTimeZone(data!);
  };

  const setAppointmentTypesOnCategoryChange = () => {
    let appointmentTypeList;

    //@TODO : Change Implementation

    if (radioOption === "OneOne") {
      if (allAppointmentTypeList.length > 0) {
        appointmentTypeList = allAppointmentTypeList.filter(
          (data) => data.appointmentCategory === "OneOne",
        )[0].types;
      }
    } else if (radioOption === "Group") {
      setAddAppointmentForm({
        ...addAppointmentForm,
        appointmentCategoryId: "Group Appointment",
      });
      if (allAppointmentTypeList.length > 0) {
        appointmentTypeList = allAppointmentTypeList.filter(
          (data) => data.appointmentCategory === "Group",
        )[0].types;
      }
    } else {
      setAddAppointmentForm({
        ...addAppointmentForm,
        appointmentCategoryId: "Group Webinar",
      });
      if (allAppointmentTypeList.length > 0) {
        appointmentTypeList = allAppointmentTypeList.filter(
          (data) => data.appointmentCategory === "Group Webinar",
        )[0].types;
      }
    }
    if (appointmentTypeList) {
      setAppointmentMetaData({
        ...appointmentMetaData,
        appointmentTypeList: appointmentTypeList,
      });
    }
  };

  const getAppointmentCategory = async () => {
    const response =
      await appointmentApi.appointmentControllerGetAppointmentCategory(
        "APP_ONE_ONE",
      );

    // const category = response.data.id;
    setAppointmentCategoryId(response.data.id);
    setAddAppointmentForm({
      ...addAppointmentForm,
      appointmentCategoryId: response.data.id,
    });
  };

  const getAppointmentDetailById = async (id: string) => {
    LoadingHelper.showLoader(".addOneOne");
    try {
      const app =
        await appointmentApi.appointmentControllerGetAppointmentById(
          id,
        );
      setAppointmentDetails(app.data!);
      const coachDetail = await usersApi.usersControllerFindOne(
        app.data.coaches[0].coachId,
      );
      setSelectedCoach(coachDetail.data);
      setCoachEmail(coachDetail.data.email!);
      setCoachTimeZone(coachDetail.data.timezone!);

      if (app.data) {
        getPatientDetailByPatientId(app.data.patients[0].patientId!);
        await getCurrentAppointmentProgressNotes(
          id,
          app.data.patients[0].patientId,
        );

        await getElligibleUsersList(app.data.patients[0].patientId!);

        const coachDetail = await usersApi.usersControllerFindOne(
          app.data.coaches[0].coachId!,
        );
        setSelectedCoach(coachDetail.data);

        setSelectedCoachTimeZone(coachDetail.data.timezone);

        const dateInCoachTimeZone = DateTime.fromJSDate(
          new Date(app.data.time!),
        ).setZone(getTzIdentifier(coachDetail.data.timezone as TimeZoneKey));

        const appointmentStartTime = new Date(
          dateInCoachTimeZone.year,
          dateInCoachTimeZone.month - 1,
          dateInCoachTimeZone.day,
          dateInCoachTimeZone.hour,
          dateInCoachTimeZone.minute,
          dateInCoachTimeZone.second,
          dateInCoachTimeZone.millisecond,
        );

        const slot = formatTime(appointmentStartTime as unknown as string);
        setTimeSlot(slot);
        setDisplayAddDate(appointmentStartTime);

        setAddAppointmentForm({
          ...addAppointmentForm,
          appointmentCategoryId: app.data.appointmentCategory.id!,
          appointmentModeId: app.data.appointmentMode.id!,
          appointmentTypeId: app.data.appointmentType.id!,
          coachIds: [app.data.coaches[0].coachId!],
          time: dateInCoachTimeZone.toJSDate(),
          patientIds: [app.data.patients[0].patientId!],
          primaryCoachUserId: app.data.coaches[0].coachName!,
          email: app.data.patients[0].email!,
          phone: app.data.patients[0].phone!,
          source: app.data.source!,
          comment:
            app.data.comments.length > 0 ? app.data.comments[0].comment : "",
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      LoadingHelper.hideLoader(".addOneOne");
    }
  };

  const getPatientDetailByPatientId = async (id: string) => {
    LoadingHelper.showLoader(".addOneOne");
    try {
      await getElligibleUsersList(id);
      const response =
        await patientApi.patientsControllerGetPatientPersonalInfo(id);
      const dobInput = document.getElementById("dobInput") as HTMLInputElement;
      const formateddob = formatDate(response.data.dob as unknown as string);
      if (dobInput) {
        dobInput.value = formateddob;
      }

      setPatientselected({
        name: response.data.firstName + " " + response.data.lastName,
        dob: response.data.dob as unknown as string,
        id: id,
      });

      const patientPersonalInfoResponse =
        await patientApi.patientsControllerGetPatientPersonalInfo(id!);

      setPatientTimeZone(patientPersonalInfoResponse.data.timeZone!);

      const emailInput = document.getElementById("Email") as HTMLInputElement;
      emailInput.value = patientPersonalInfoResponse.data.email;

      const phoneInput = document.getElementById("Phone") as HTMLInputElement;
      phoneInput.value = patientPersonalInfoResponse.data.phone;

      const category =
        await appointmentApi.appointmentControllerGetAppointmentCategory(
          "APP_ONE_ONE",
        );
      const patientids = [];
      if (patientId && patientids.length < 1) {
        patientids.push(patientId);
        setAddAppointmentForm({
          ...addAppointmentForm,
          patientIds: patientids,
          phone: response.data.phone,
          email: response.data.email,
          appointmentCategoryId: category.data.id,
        });
      }

      setPatient(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      LoadingHelper.hideLoader(".addOneOne");
    }
  };

  const loadPatients = async (query: string) => {
    if (!query) {
      setPatientTypeHeadList([]);
      return;
    }
    try {
      const response = await patientApi.patientsControllerSearchPatient(query);
      const results = response.data.map((result: any) => ({
        key: result.key, // Use id as the key
        value: result.value, // Display name as the value
        dob: result.infoDate,
      }));
      setPatientTypeHeadList(results);
    } catch (error) {
      console.error("Error fetching coaches:", error);
    }
  };

  const submitHandler = async (e: React.FormEvent<HTMLFormElement>) => {
    setSubmitClicked(true);
    hideEventCalendar();

    e.preventDefault();
    setValidated(true);

    if (!timeSlot) {
      return;
    }

    const form = e.currentTarget;

    if (!form.checkValidity()) {
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    if (addAppointmentForm.coachIds.length > 0) setConfirmPage(true);
    else handleOpenToaster("Invalid Coach", "error");

    if (appointmentId) handleUpdate();
  };

  const getAppointmentModes = async () => {
    try {
      const response =
        await appointmentApi.appointmentControllerGetAppointmentMode();

      setMode(response.data.filter((m) => m.isDeleted === false));
    } catch (error) {}
  };

  const getAppointmentTypes = async () => {
    try {
      const category =
        await appointmentApi.appointmentControllerGetAppointmentCategory(
          "APP_ONE_ONE",
        );

      setAppointmentCategoryId(category.data.id);
      setAddAppointmentForm({
        ...addAppointmentForm,
        appointmentCategoryId: category.data.id,
      });

      const response =
        await appointmentApi.appointmentControllerGetAppointmentTypesByCategory(
          category.data.id,
        );

      setAppointmentType(response.data);
    } catch (error) {}
  };

  const handleDiscard = () => {
    setOffCanvasShow(false);
  };

  const targetChangeHandlar = (
    args: MbscDatepickerCellClickEvent,
    inst: DatepickerBase,
  ) => {
    const date = new Date(args.date!);

    setTimeSlot(null);
    setDisplayAddDate(date);

    setUpdateDate(true);
    setAddAppointmentForm({
      ...addAppointmentForm,
      time: date,
    });

    setchange(true);
  };
  const handleDropdownChange = async (event: any) => {
    setAddAppointmentForm((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  };

  useEffect(() => {
    const getUsersByAppointmentType = async () => {
      try {
        setLoading(true);
        const appTypeUsers = (
          await appointmentApi.appointmentControllerGetUsersByAppointmentType(
            addAppointmentForm.appointmentTypeId,
          )
        ).data;
        setCoachesForSelectedAppointment(appTypeUsers);
      } catch (error) {
        setCoachesForSelectedAppointment([]);
        console.error("Error while fetching coaches", error);
      } finally {
        setLoading(false);
      }
    };
    if (addAppointmentForm.appointmentTypeId) {
      getUsersByAppointmentType();
    } else {
      setCoachesForSelectedAppointment([]);
    }
  }, [addAppointmentForm.appointmentTypeId]);

  useEffect(() => {
    const getUsersByPatient = async () => {
      try {
        setLoading(true);
        const response = await usersApi.usersControllerSearchUsers(
          addAppointmentForm.patientIds[0],
          undefined,
        );
        setCoachesForSelectedPatient(response.data);
      } catch (error) {
        setCoachesForSelectedPatient([]);
        console.error("Error while fetching coaches", error);
      } finally {
        setLoading(false);
      }
    };
    if (addAppointmentForm.patientIds.length) {
      getUsersByPatient();
    } else {
      setCoachesForSelectedPatient([]);
    }
  }, [addAppointmentForm.patientIds]);

  useEffect(() => {
    const setData = async () => {
      setLoading(true);
      let commonUsers = [];
      if (
        (coachesForSelectedPatient.length &&
          addAppointmentForm.appointmentTypeId &&
          !coachesForSelectedAppointment.length) ||
        (addAppointmentForm.appointmentTypeId &&
          coachesForSelectedAppointment.length &&
          !coachesForSelectedPatient.length)
      ) {
        commonUsers = [];
      } else if (
        coachesForSelectedPatient.length &&
        !addAppointmentForm.appointmentTypeId
      ) {
        commonUsers = coachesForSelectedPatient;
      } else {
        commonUsers = coachesForSelectedAppointment.filter((user) =>
          coachesForSelectedPatient.some((appUser) => appUser.key === user.key),
        );
      }
      if (
        addAppointmentForm.appointmentTypeId ===
        AppointmentTypesConstants.INITIAL_ASSESSMENT
      ) {
        let userIds: any = commonUsers.map((user: any) => user.key);
        userIds = userIds.toString();

        const patientsCount = (
          await patientApi.patientsControllerGetUserPatientsCounts(userIds)
        ).data;

        // Convert patientsCount array into a dictionary for quick lookup
        const patientsMap: Record<string, number> = patientsCount.reduce(
          (acc, item) => {
            acc[item.userId] = item.patinetsCount;
            return acc;
          },
          {} as Record<string, number>,
        );

        // Map through users and attach patientsCount
        const updatedUsers = commonUsers.map((user) => ({
          ...user,
          patientsCount: patientsMap[user.key] || 0, // Default to 0 if not found
        }));

        // Sort updatedUsers by patientsCount in ascending order
        const sortedUsers = updatedUsers.sort(
          (a, b) => (a.patientsCount ?? 0) - (b.patientsCount ?? 0),
        );

        setElligibleUsers(sortedUsers);
      } else {
        setElligibleUsers(commonUsers);
      }
      setLoading(false);
    };
    setData();
  }, [coachesForSelectedAppointment, coachesForSelectedPatient]);

  const handleInputChange = (event: any) => {
    setAddAppointmentForm((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
    setEditableNote(event.target.value);
  };

  const handleOpenToaster = (message: string, type: string) => {
    setOpenToaster({
      message,
      show: true,
      type,
    });
  };

  const generateTimeSlots = async () => {
    if (addAppointmentForm.coachIds.length < 1) {
      return;
    }

    const localDate = new Date(addAppointmentForm.time);

    const startOfLocalDayUTC = new Date(localDate);
    startOfLocalDayUTC.setHours(0, 0, 0, 0);

    const endOfLocalDayUTC = new Date(localDate);
    endOfLocalDayUTC.setHours(24, 0, 0, 0);

    const timezoneOffsetMillis =
      startOfLocalDayUTC.getTimezoneOffset() * 60 * 1000;

    const utcDateTimeStart = new Date(
      startOfLocalDayUTC.getTime() + timezoneOffsetMillis,
    );

    const timezoneOffsetMilli =
      endOfLocalDayUTC.getTimezoneOffset() * 60 * 1000;

    const utcDateTimeEnd = new Date(
      endOfLocalDayUTC.getTime() + timezoneOffsetMilli,
    );

    const coachDetail = await usersApi.usersControllerFindOne(
      addAppointmentForm.coachIds[0],
    );

    const requestDayStart: BookedSlotsRequest = {
      coachUserId: addAppointmentForm.coachIds[0],
      patientId: addAppointmentForm.patientIds[0],
      date: getLocalDateString(utcDateTimeStart),
    };
    const requestDayEnd: BookedSlotsRequest = {
      coachUserId: addAppointmentForm.coachIds[0],
      patientId: addAppointmentForm.patientIds[0],
      date: getLocalDateString(utcDateTimeEnd),
    };

    const appointmentTypes =
      await appointmentApi.appointmentControllerGetAllAppointmentTypes();
    const typeMap = new Map(
      appointmentTypes.data.map((type) => [type.id, type]),
    );
    const currentAppointmentType = typeMap.get(
      addAppointmentForm.appointmentTypeId,
    );
    const currentAppointmentPreBuffer =
      currentAppointmentType?.preDurationMinutes ?? 0;
    const currentAppointmentPostBuffer =
      currentAppointmentType?.postDurationMinutes ?? 0;

    let currentAppointmentTotalTimeNeeded;

    if (overrideBufferSlots) {
      currentAppointmentTotalTimeNeeded =
        currentAppointmentType!.durationMinutes;
    } else {
      currentAppointmentTotalTimeNeeded =
        currentAppointmentType!.durationMinutes +
        currentAppointmentPostBuffer +
        currentAppointmentPreBuffer;
    }

    const responseStart =
      await appointmentApi.appointmentControllerGetBookedAppointmentTimeSlots(
        requestDayStart,
      );
    const responseEnd =
      await appointmentApi.appointmentControllerGetBookedAppointmentTimeSlots(
        requestDayEnd,
      );

    const unavailableBookedSlotsStart: TimeSlot[] = responseStart.data.map(
      (appointment) => {
        const dateInCoachTimeZone = DateTime.fromJSDate(
          new Date(appointment.time),
        ).setZone(getTzIdentifier(coachDetail.data.timezone as TimeZoneKey));

        const appointmentStartTime = new Date(
          dateInCoachTimeZone.year,
          dateInCoachTimeZone.month - 1,
          dateInCoachTimeZone.day,
          dateInCoachTimeZone.hour,
          dateInCoachTimeZone.minute,
          dateInCoachTimeZone.second,
          dateInCoachTimeZone.millisecond,
        );

        const appointmentType = typeMap.get(appointment.appointmentTypeId);
        const preBuffer = appointmentType?.preDurationMinutes ?? 0;
        const postBuffer = appointmentType?.postDurationMinutes ?? 0;

        // Adjusted start and end times with buffer
        const adjustedStart = new Date(appointmentStartTime);
        const adjustedEnd = new Date(appointmentStartTime);

        adjustedStart.setMinutes(adjustedStart.getMinutes());
        adjustedEnd.setMinutes(
          adjustedEnd.getMinutes() + Number(appointment.durationMinutes),
        );

        return {
          start: adjustedStart,
          end: adjustedEnd,
          pre: preBuffer,
          post: postBuffer,
          isOutlook: false,
        };
      },
    );

    const unavailableBookedSlotsEnd: TimeSlot[] = responseEnd.data.map(
      (appointment) => {
        const dateInCoachTimeZone = DateTime.fromJSDate(
          new Date(appointment.time),
        ).setZone(getTzIdentifier(coachDetail.data.timezone as TimeZoneKey));

        const appointmentStartTime = new Date(
          dateInCoachTimeZone.year,
          dateInCoachTimeZone.month - 1,
          dateInCoachTimeZone.day,
          dateInCoachTimeZone.hour,
          dateInCoachTimeZone.minute,
          dateInCoachTimeZone.second,
          dateInCoachTimeZone.millisecond,
        );

        const appointmentType = typeMap.get(appointment.appointmentTypeId);
        const preBuffer = appointmentType?.preDurationMinutes ?? 0;
        const postBuffer = appointmentType?.postDurationMinutes ?? 0;

        // Adjusted start and end times with buffer
        const adjustedStart = new Date(appointmentStartTime);
        const adjustedEnd = new Date(appointmentStartTime);

        adjustedStart.setMinutes(adjustedStart.getMinutes());
        adjustedEnd.setMinutes(
          adjustedEnd.getMinutes() + Number(appointment.durationMinutes),
        );

        return {
          start: adjustedStart,
          end: adjustedEnd,
          pre: preBuffer,
          post: postBuffer,
          isOutlook: false,
        };
      },
    );

    const coachAvailabilityStart =
      await usersApi.usersControllerGetUserAvailabilities(
        addAppointmentForm.coachIds[0],
        getLocalDateString(utcDateTimeStart),
      );

    const unavailableRangesStart = prepareUnavailableRanges(
      coachAvailabilityStart.data,
      coachDetail.data.timezone as TimeZoneKey,
    );

    const coachAvailabilityEnd =
      await usersApi.usersControllerGetUserAvailabilities(
        addAppointmentForm.coachIds[0],
        getLocalDateString(utcDateTimeEnd),
      );

    const unavailableRangesEnd = prepareUnavailableRanges(
      coachAvailabilityEnd.data,
      coachDetail.data.timezone as TimeZoneKey,
    );

    const allUnavailableRanges = [
      ...unavailableRangesStart,
      ...unavailableRangesEnd,
      ...unavailableBookedSlotsStart,
      ...unavailableBookedSlotsEnd,
      ...(displayBlockedOutlookTimeSlots ? [] : userCalendarUnavailableRanges),
    ];

    const appointmentDuration =
      appointmentType.find(
        (at) => at.id == addAppointmentForm.appointmentTypeId,
      )?.durationMinutes || 0;

    const startOfDay = new Date(addAppointmentForm.time);
    startOfDay.setHours(7, 0, 0, 0);

    const endOfDay = new Date(addAppointmentForm.time);
    endOfDay.setHours(18, 0, 0, 0);

    const currentAppointmentDuration = currentAppointmentType!.durationMinutes;

    const start = new Date(startOfDay);
    const end = new Date(endOfDay);

    const slots = [];

    while (start <= end) {
      const hours = start.getHours();
      const minutes = start.getMinutes();
      const amPm = hours >= 12 ? "PM" : "AM";
      const formattedHours = hours % 12 || 12;
      const formattedMinutes = minutes.toString().padStart(2, "0");
      const hour = formattedHours.toString().padStart(2, "0");
      const formattedSlot = `${hour}:${formattedMinutes} ${amPm}`;

      const slotStart = new Date(start);

      const fullAppointmentStart = new Date(slotStart);
      const fullAppointmentEnd = new Date(fullAppointmentStart);
      fullAppointmentEnd.setMinutes(
        fullAppointmentEnd.getMinutes() + currentAppointmentDuration,
      );

      const isUnavailable =
        allUnavailableRanges.some(
          ({
            start: rangeStart,
            end: rangeEnd,
            pre = 0,
            post = 0,
            isOutlook,
          }) => {
            const adjustedStart =
              overrideBufferSlots || isOutlook
                ? rangeStart
                : new Date(
                    rangeStart.getTime() -
                      Math.max(currentAppointmentPostBuffer, pre) * 60000,
                  );

            const adjustedEnd =
              overrideBufferSlots || isOutlook
                ? rangeEnd
                : new Date(
                    rangeEnd.getTime() +
                      Math.max(currentAppointmentPreBuffer, post) * 60000,
                  );

            return (
              fullAppointmentStart < adjustedEnd &&
              fullAppointmentEnd > adjustedStart
            );
          },
        ) || fullAppointmentEnd > endOfDay;

      slots.push({
        slot: formattedSlot,
        disabled: isUnavailable,
      });

      start.setMinutes(start.getMinutes() + 30);
    }

    return slots;
  };

  const handleTimeSlotChange = async (e: any) => {
    const selectedTime = e.target.value;
    setTimeSlotSelected(true);
    setTimeSlot(selectedTime);
    const localDate = new Date(addAppointmentForm.time);
    setUpdateDate(true);

    const coachDetail = await usersApi.usersControllerFindOne(
      addAppointmentForm.coachIds[0],
    );

    const coachZipCodeDetails =
      await locationApi.locationControllerGetZipcodeDetails(
        coachDetail.data.zipcode,
      );

    const localDateTime = new Date(
      `${localDate.toDateString()} ${selectedTime}`,
    );

    const keepZone = DateTime.fromObject(
      {
        year: localDateTime.getFullYear(),
        month: localDateTime.getMonth() + 1,
        day: localDateTime.getDate(),
        hour: localDateTime.getHours(),
        minute: localDateTime.getMinutes(),
      },
      { zone: getTzIdentifier(coachDetail.data.timezone as TimeZoneKey) },
    );
    const jsDate = keepZone.toJSDate();

    setDisplayAddDate(localDateTime);

    setAddAppointmentForm({
      ...addAppointmentForm,
      time: jsDate,
    });
  };

  const CalendarComp = (
    <div className="offcanvas-date-time">
      <div className="row">
        {/* Date Picker Component */}
        <div className="col-md-12 mb-3">
          <div className="offcanvas-date-time">
            <label
              htmlFor="DateTime"
              className="form-label fs-12 fw-semibold mb-1"
            >
              Select Date
            </label>
            {
              // Display Calendar icon if coach is selected
              coachEmail && (
                <span
                  className="cursor-pointer float-end a-link a-underline"
                  onClick={
                    showEventCalendar ? hideEventCalendar : displayEventCalendar
                  }
                >
                  <a className="fs-14 me-1 text-decoration-underline">
                    {showEventCalendar ? "Hide Calendar" : "Show Calendar"}
                  </a>
                  <OutlookCalendar />
                </span>
              )
            }
            <Datepicker
              controls={["calendar"]}
              value={displayAddDate}
              theme="windows"
              themeVariant="light"
              display="inline"
              touchUi={true}
              min={currentDate.toDateString()}
              invalid={invalidDates}
              onCellClick={targetChangeHandlar} // Handles date changes
              onPageChange={monthChangeHandler} // Handles month changes
              cssClass={"calendars"}
              required
            />
          </div>
        </div>

        {/* Time Slot Dropdown */}
        <div className="col-md-12 border border-1 rounded mb-3">
          <div className="row mt-2">
            <div className="mb-3 col-md-6">
              <div className="fs-12 fw-semibold">Coach / Patient</div>
              <div className="fs-12 mt-3">
                {displayTimezone.coach} / {displayTimezone.patient}
              </div>
            </div>

            <div className="mb-3 col-md-6 fs-12">
              <label
                htmlFor="timeSlot"
                className="form-label fs-12 fw-semibold mb-1"
              >
                Select Time Slot
              </label>
              <select
                id="timeSlot"
                className={`form-control form-control-sm ${
                  !timeSlot && submitClicked ? "is-invalid" : ""
                }`}
                value={timeSlot || ""}
                onChange={(e) => handleTimeSlotChange(e)}
                required
              >
                {availableSlots.every((av) => av.disabled) ? (
                  <option value="">No slots available</option>
                ) : (
                  <>
                    <option value={""} selected={!timeSlotSelected} disabled>
                      Select Time
                    </option>
                    {availableSlots.map((slotObj, index) => (
                      <option
                        style={{
                          fontWeight: !slotObj.disabled ? "bold" : "normal",
                        }}
                        key={index}
                        value={slotObj.slot}
                        disabled={slotObj.disabled} // Disable the slot if it's booked
                      >
                        {slotObj.slot} / {patientSlots[index]}
                      </option>
                    ))}
                  </>
                )}
              </select>
            </div>
          </div>
          <div className="row mb-2">
            <div className="fs-12 fw-semibold mt-2">
              Include Blocked Outlook Events
            </div>
            <div className="fs-12 mt-2">
              <input
                type="checkbox"
                checked={displayBlockedOutlookTimeSlots}
                onClick={() => {
                  setDisplayBlockedOutlookTimeSlots(
                    !displayBlockedOutlookTimeSlots,
                  );
                }}
                onChange={() => {}}
              ></input>
            </div>
          </div>
          <div className="row mb-2">
            <div className="fs-12 fw-semibold mt-2">Override Appt. Buffer</div>
            <div className="fs-12 mt-2">
              <input
                type="checkbox"
                checked={overrideBufferSlots}
                onClick={() => {
                  setOverrideBufferSlots(!overrideBufferSlots);
                }}
                onChange={() => {}}
              ></input>
            </div>
          </div>
        </div>
      </div>
    </div>
  );

  const selectPatient = async (selected: any) => {
    if (!selected) {
      setLoading(false);
      return;
    }
    try {
      setLoading(true);

      let patientArray = [...addAppointmentForm.patientIds]; // Create a copy of the array to avoid mutation

      if (patientArray.length >= 1) {
        // If there's already an item and selected has a key, reset the array
        if (selected.key) {
          patientArray = []; // Reset array
        }
      }

      // Set selected patient details
      setPatientselected({
        name: selected.value,
        dob: selected.dob,
        id: selected.key,
      });

      // Add the new patient ID
      patientArray.push(selected.key);

      // Update the state with the new array
      setAddAppointmentForm({
        ...addAppointmentForm,
        patientIds: patientArray, // Replace the array in the state with the new one
      });

      await getElligibleUsersList(selected.key);

      const response =
        await patientApi.patientsControllerGetPatientPersonalInfo(selected.key);
      setPatientTimeZone(response.data.timeZone!);
      const emailInput = document.getElementById("Email") as HTMLInputElement;
      emailInput.value = response.data.email;

      const phoneInput = document.getElementById("Phone") as HTMLInputElement;
      phoneInput.value = response.data.phone;

      setAddAppointmentForm({
        ...addAppointmentForm,
        patientIds: patientArray,
        phone: response.data.phone,
        email: response.data.email,
      });

      const dobInput = document.getElementById("dobInput") as HTMLInputElement;
      const formateddob = formatDate(selected.dob);
      if (dobInput) {
        dobInput.value = formateddob;
      }
    } catch (error: any) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const setFormBack = async (data: SaveAppointmentRequest) => {
    setLoading(true);
    setIsPatientLoading(true);
    setAddAppointmentForm(data);
    try {
      const response =
        await patientApi.patientsControllerGetPatientPersonalInfo(
          data.patientIds[0],
        );

      const name = response.data.firstName + " " + response.data.lastName;

      const fetchedPatient = {
        key: data.patientIds[0],
        value: name,
      };

      setPatientSelectedonback(fetchedPatient);
      setPatientselected({
        name: name,
        dob: response.data.dob as unknown as string,
        id: data.patientIds[0],
      });

      setPatientTimeZone(response.data.timeZone!);

      const emailInput = document.getElementById("Email") as HTMLInputElement;
      emailInput.value = response.data.email;

      const phoneInput = document.getElementById("Phone") as HTMLInputElement;
      phoneInput.value = response.data.phone;

      setAddAppointmentForm({
        ...addAppointmentForm,
        phone: response.data.phone,
        email: response.data.email,
      });

      const dobInput = document.getElementById("dobInput") as HTMLInputElement;
      const formateddob = formatDate(response.data.dob as unknown as string);
      if (dobInput) {
        dobInput.value = formateddob;
      }

      const coachDetail = await usersApi.usersControllerFindOne(
        data.coachIds[0],
      );

      const fetchedCoach = {
        key: data.coachIds[0],
        value: coachDetail.data.firstName + " " + coachDetail.data.lastName,
      };
      setcoachselectedonback(fetchedCoach);

      setCoachTimeZone(coachDetail.data.timezone!);
    } catch (error) {
      console.error("Error fetching patient or coach details:", error);
    } finally {
      setLoading(false);
      setIsPatientLoading(false);
    }
  };

  // Function to handle coach selection
  const selectCoach = async (event: React.ChangeEvent<HTMLSelectElement>) => {
    setLoading(true);
    displayEventCalendar();
    setAddAppointmentForm((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));

    let patientarray = addAppointmentForm.coachIds;
    if (patientarray.length >= 1) {
      if (event.target.value) {
        patientarray = [];
      }
    }
    patientarray.push(event.target.value);

    const coachDetail = await usersApi.usersControllerFindOne(
      event.target.value,
    );
    setSelectedCoach(coachDetail.data);

    setCoachTimeZone(coachDetail.data.timezone!);
    setCoachEmail(coachDetail.data.email);

    const coachZipCodeDetails =
      await locationApi.locationControllerGetZipcodeDetails(
        coachDetail.data.zipcode,
      );

    setSelectedCoachTimeZone(coachDetail.data.timezone);

    await setAddAppointmentForm({
      ...addAppointmentForm,
      coachIds: patientarray,
    });
    await fetchBookedSlots();
  };

  const formatDate = (isoDateString: string): string => {
    const date = new Date(isoDateString);
    const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Months are zero-based
    const day = String(date.getUTCDate()).padStart(2, "0");
    const year = date.getUTCFullYear();
    return `${month}-${day}-${year}`;
  };

  useEffect(() => {
    confirmPageAction && confirmPageAction(confirmPage);
  }, [confirmPage]);

  const getStatusId = async (statusName: string): Promise<string> => {
    const appointmentdetails =
      await appointmentApi.appointmentControllerGetAppointmentById(
        appointmentId!,
      );
    const appointment: AppointmentDto = appointmentdetails.data;
    if (appointment.status.stateName === statusName) {
      return appointment.status.stateId;
    }
    const noShowState = appointment.status.nextStates.find(
      (state: WorkflowState) => state.stateName === statusName,
    );

    return noShowState.stateId;
  };

  const handleUpdate = async () => {
    const statusId = await getStatusId("Rescheduled");
    if (!updateDate) {
      setUpdateAppointmentForm({
        ...updateAppointmentForm,
        appointmentModeId: addAppointmentForm.appointmentModeId!,
        appointmentTypeId: addAppointmentForm.appointmentTypeId!,
        comment: addAppointmentForm.comment,
        status: statusId,
      });
    } else {
      setUpdateAppointmentForm({
        ...updateAppointmentForm,
        appointmentModeId: addAppointmentForm.appointmentModeId!,
        appointmentTypeId: addAppointmentForm.appointmentTypeId!,
        appointmentTime: addAppointmentForm.time,
        comment: addAppointmentForm.comment,
        status: statusId,
      });
    }
  };

  const unsetPatientId = () => {
    setAddAppointmentForm({
      ...addAppointmentForm,
      patientIds: [],
    });
  };

  const openInNewTab = (url: string) => {
    const newWindow = window.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };

  const getElligibleUsersList = async (patientId: string) => {
    const users = await usersApi.usersControllerSearchUsers(
      patientId,
      undefined,
    );

    setCoachesForSelectedPatient(users.data);
  };

  const getCurrentAppointmentProgressNotes = async (
    appointmentId: string,
    patientId: string,
  ) => {
    try {
      const lastAppointmentNotes =
        await clinicalformsApi.clinicalFormsControllerGetMemberForms(
          patientId,
          ClinicalFormsConstants.careNoteType,
        );

      const submittedForms = lastAppointmentNotes.data.filter(
        (form) => form.sourceRefId === appointmentId,
      );

      if (submittedForms.length == 0 || !submittedForms) {
        return;
      }

      setProgressNotesId(submittedForms[0].id);

      if (submittedForms[0].id) {
        const formAnswers = (
          await clinicalformsApi.clinicalFormsControllerGetMemberAnswers(
            submittedForms[0].id,
          )
        ).data;
        setAnswers(formAnswers.formAnswers);
        setAdditionalAnswers(formAnswers.additionalAnswers!);
        const comment = stripHtmlTags(formAnswers.comments ?? "");
        setEditableNote(comment);

        setAddAppointmentForm({
          ...addAppointmentForm,
          comment:
            formAnswers.comments && formAnswers.comments.length > 0
              ? formAnswers.comments
              : "",
        });
      }
    } catch (error: any) {
      console.error(error);
    }
  };

  const getAppointmentRescheduledReasons = async () => {
    const reasons =
      await appointmentApi.appointmentControllerGetAppointmentRescheduledReasons();
    setRescheduledReasons(reasons.data);
  };

  return (
    <>
      {loading && <Spinner />}
      <Form noValidate validated={validated} onSubmit={submitHandler}>
        {confirmPage ? (
          <Confirm
            setForm={setFormBack}
            selectedPatients={patientselected}
            appointmentData={addAppointmentForm}
            setConfirmPage={setConfirmPage}
            confirmType={confirmType}
            offCanvasShow={offCanvasShow}
            setOpenToaster={handleOpenToaster}
            patientTimeZone={patientTimeZone}
            coachTimeZone={coachTimeZone}
            setOffCanvasShow={setOffCanvasShow!}
            setOffCanvasComp={setOffCanvasComp!}
            appointmentId={appointmentId}
            updateAppointmentData={updateAppointmentForm}
            loadAppointmentDetails={loadAppointmentDetails}
            reloadGrid={reloadGrid}
            date={displayAddDate}
            selectedCoachTimeZone={selectedCoachTimeZone}
            progressNotesId={progressNotesId}
          />
        ) : (
          <div className="d-flex align-items-start flex-column h-100 addOneOne ">
            <div className="d-flex col-12 gap-4">
              <div
                className={`${
                  offCanvasComp === "eventCalendar" ? "col-4" : "col-12"
                }`}
              >
                <hr className="my-2" />

                <div className="alert alert-warning py-2 px-3 mb-2 fs-12" role="alert">
                  <span className="material-symbols-outlined fs-14 align-text-top me-1">warning</span>
                  This scheduling experience will be removed in a future release. If there is specific feedback you have or features you would like to see, please reach out to your manager.
                </div>

                <>
                  <div className="d-flex mb-3">
                    <div className="flex-fill position-relative">
                      <div>
                        <label
                          htmlFor="patient"
                          className="form-label fs-12 fw-semibold mb-1"
                        >
                          Patient
                        </label>
                        {patientId ? (
                          <a
                            className="float-end fs-12 text-secondary a-link a-underline"
                            href="#"
                            onClick={() => {
                              openInNewTab(`/patients/${patientId}/summary`);
                            }}
                          >
                            View Profile
                          </a>
                        ) : (
                          ""
                        )}
                        {!patientId && addAppointmentForm.patientIds[0] ? (
                          <a
                            className="float-end fs-12 text-secondary a-link a-underline"
                            href="#"
                            onClick={() => {
                              openInNewTab(
                                `/patients/${addAppointmentForm.patientIds[0]}/summary`,
                              );
                            }}
                          >
                            View Profile
                          </a>
                        ) : (
                          ""
                        )}
                      </div>
                      <div>
                        {patientId || appointmentId ? (
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            value={
                              patient !== null
                                ? patient?.firstName + " " + patient?.lastName
                                : ""
                            } // Assuming `name` is a field in patientDetails
                            disabled
                          />
                        ) : (
                          // Else, show the AsyncTypeahead for patient search
                          <AsyncTypeahead
                            name="patient"
                            options={patientsList}
                            callback={loadPatients}
                            onSelect={selectPatient}
                            placeholder={"Search Patient"}
                            required={true}
                            unsetId={unsetPatientId}
                            defaultValue={
                              isPatientLoading
                                ? null
                                : patientselectedonback?.value
                            }
                          />
                        )}
                      </div>
                    </div>
                    <div className="ms-2 w-35">
                      <label
                        htmlFor="targetDate"
                        className="form-label fs-12 fw-semibold mb-1"
                      >
                        DOB
                      </label>
                      <div className="position-relative">
                        <input
                          type="text"
                          id="dobInput" // Add id here
                          className="form-control form-control-sm"
                          placeholder="MM-DD-YYYY"
                          disabled
                          required
                        />
                        <span className="material-symbols-outlined fs-18 calendar-icon">
                          calendar_month
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex mb-3">
                    <div className="flex-fill">
                      <label
                        htmlFor="Email"
                        className="form-label fs-12 fw-semibold mb-1"
                      >
                        Email
                      </label>
                      <input
                        type="text"
                        placeholder="Email"
                        className="form-control form-control-sm"
                        id="Email"
                        readOnly
                      />
                    </div>

                    <div className="ms-2 w-35">
                      <label
                        htmlFor="Phone"
                        className="form-label fs-12 fw-semibold mb-1"
                      >
                        Phone
                      </label>
                      <input
                        type="text"
                        placeholder="Phone"
                        className="form-control form-control-sm"
                        id="Phone"
                        readOnly
                      />
                    </div>
                  </div>
                </>

                <div className="d-flex mb-3">
                  <div className="flex-fill">
                    <label
                      htmlFor="AppointmentType"
                      className="form-label fs-12 fw-semibold mb-1"
                    >
                      Appointment Type
                    </label>

                    <select
                      className="form-select form-select-sm"
                      id="AppointmentType"
                      value={addAppointmentForm.appointmentTypeId}
                      name="appointmentTypeId"
                      onChange={(e) => handleDropdownChange(e)}
                      required
                    >
                      <option value="">Select Type</option>
                      {appointmentType.length > 0 &&
                        appointmentType.map(
                          (type: AppointmentType, index: number) => (
                            <option key={index} value={type.id}>
                              {type.name}
                            </option>
                          ),
                        )}
                    </select>
                  </div>
                  <div className="ms-2 w-35">
                    <label
                      htmlFor="Mode"
                      className="form-label fs-12 fw-semibold mb-1"
                    >
                      Mode
                    </label>
                    <select
                      className="form-select form-select-sm"
                      id="Mode"
                      value={addAppointmentForm.appointmentModeId}
                      name="appointmentModeId"
                      onChange={(e) => handleDropdownChange(e)}
                      required
                    >
                      <option value="">Select</option>
                      {mode.length > 0 &&
                        mode.map((data: AppointmentMode, index: number) => (
                          <option key={index} value={data.id}>
                            {data.name}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>

                {radioOption !== "OneOne" && (
                  <div className="mb-3">
                    <label
                      htmlFor="RecurringOneTime"
                      className="form-label fs-12 fw-semibold mb-1"
                    >
                      Recurring or One Time
                    </label>
                    <select
                      className="form-select form-select-sm"
                      id="RecurringOneTime"
                      value={addAppointmentForm.reccuringFrequency}
                      name="occurrence"
                      onChange={(e) => handleDropdownChange(e)}
                      required
                    >
                      <option value="">Select Occurrence</option>
                      {appointmentMetaData.appointmentOccurrenceList.length >
                        0 &&
                        appointmentMetaData.appointmentOccurrenceList.map(
                          (type: IdLabelPair, index: number) => (
                            <option key={index} value={type.label}>
                              {type.label}
                            </option>
                          ),
                        )}
                    </select>
                  </div>
                )}

                <div className="mb-3">
                  <label
                    htmlFor="assignTo"
                    className="form-label fs-12 fw-semibold mb-1"
                  >
                    Select Coach
                  </label>
                  {appointmentId ? (
                    <input
                      type="text"
                      className="form-control"
                      value={appointmentDetails?.coaches[0].coachName} // Assuming `name` is a field in patientDetails
                      disabled
                    />
                  ) : (
                    <select
                      className="form-select form-select-sm"
                      id="coachUserId"
                      value={addAppointmentForm.coachIds[0]}
                      name="coachUserId"
                      onChange={(e) => selectCoach(e)}
                      required
                    >
                      <option value="">Select Coach</option>
                      {elligibleUsers.length > 0 &&
                        elligibleUsers
                          .sort(
                            addAppointmentForm.appointmentTypeId !==
                              AppointmentTypesConstants.INITIAL_ASSESSMENT
                              ? (a, b) => {
                                  if (
                                    a.value.length > 1 &&
                                    b.value.length > 1
                                  ) {
                                    const fw =
                                      a.value.split(" ").length > 2
                                        ? a.value.split(" ").slice(1)[0]
                                        : a.value.split(" ").slice(0)[0];
                                    const sw =
                                      b.value.split(" ").length > 2
                                        ? b.value.split(" ").slice(1)[0]
                                        : b.value.split(" ").slice(0)[0];
                                    return fw.localeCompare(sw);
                                  } else {
                                    return a.value.localeCompare(b.value);
                                  }
                                }
                              : () => 0, // No sorting needed, keep original order
                          )
                          .map((data: TypeHeadBase, index: number) => (
                            <option key={data.key} value={data.key}>
                              {data.value.trim()}{" "}
                              {/* Trimming unnecessary spaces */}
                            </option>
                          ))}
                    </select>
                  )}
                </div>

                {CalendarComp}

                {appointmentId && (
                  <div className="d-flex mb-3">
                    <div className="flex-fill">
                      <label
                        htmlFor="rescheduledReason"
                        className="form-label fs-12 fw-semibold mb-1"
                      >
                        <p className="mb-1">
                          <span className="text-dark">Reschedule Reason</span>
                          <span className="text-danger">*</span>
                        </p>
                      </label>

                      <select
                        className="form-select form-select-sm"
                        id="rescheduledReason"
                        value={updateAppointmentForm.rescheduledReason}
                        name="rescheduledReason"
                        onChange={(e) =>
                          setUpdateAppointmentForm({
                            ...updateAppointmentForm,
                            rescheduledReason: e.target.value,
                          })
                        }
                        required
                      >
                        <option value="">Select Reason</option>
                        {rescheduledReasons.length > 0 &&
                          rescheduledReasons.map(
                            (
                              type: AppointmentRescheduledReason,
                              index: number,
                            ) => (
                              <option key={index} value={type.id}>
                                {type.reasonName}
                              </option>
                            ),
                          )}
                      </select>
                    </div>
                  </div>
                )}

                <div className="mb-3">
                  <label
                    htmlFor="Notes"
                    className="form-label fs-12 fw-semibold mb-1"
                  >
                    Notes(optional)
                  </label>
                  <textarea
                    name="comment"
                    className="form-control form-control-sm"
                    id="Notes"
                    placeholder="Add relevant notes"
                    value={
                      appointmentId ? editableNote : addAppointmentForm.comment
                    }
                    rows={3}
                    onInput={(e) => handleInputChange(e)}
                  ></textarea>
                </div>
              </div>

              {showEventCalendar && selectedCoach && (
                <div className="col-8" style={{ height: "55rem" }}>
                  <AppointmentEventCalendar
                    selectedDate={addAppointmentForm.time}
                    updateSelectedDate={(date: Date) => {
                      setDisplayAddDate(date);
                      setTimeSlot(null);
                      setAddAppointmentForm({
                        ...addAppointmentForm,
                        time: date,
                      });
                    }}
                    // setSelectedDate={setDisplayAddDate}
                    user={selectedCoach}
                    viewType="week"
                  />
                </div>
              )}
            </div>

            {/* <div className="offcanvas-footer text-end w-100 border-top">
        <button
          className="btn btn-sm btn-primary rounded-pill px-5"
          onClick={(e) => handleNextClick(e)}
          type="submit"
        >
          Next
        </button>
      </div> */}
            <div className="offcanvas-footer text-end w-100 border-top d-flex justify-content-between border-top">
              <div>
                <button
                  className="btn btn-sm btn-outline-secondary rounded-pill px-5 fs-13"
                  type="reset"
                  onClick={handleDiscard}
                >
                  Discard
                </button>
              </div>
              <div>
                <button
                  className="btn btn-sm btn-secondary rounded-pill px-5 fs-13"
                  type="submit"
                  disabled={loading || !enableSubmit}
                >
                  <span className="material-symbols-outlined fs-16 align-text-top"></span>
                  Next
                </button>
              </div>
            </div>
          </div>
        )}
      </Form>
    </>
  );
};
export default AddOneOne;
